import { JwtTokenFn } from "./jwt.token";
import { UserData } from "./user.data";
import { DebugLog } from "@me8eon/debug";

export type LoginOutFn = (debugLog: DebugLog) => Promise<string | undefined>

export type LoginConfig = {
    type: "msal" | "teams"
    refreshLogin: LoginOutFn
    login: LoginOutFn
    logout: LoginOutFn
    jwtToken: JwtTokenFn
}
export type LoginOps = {
    //Doesn't pop open a new window, but logs in if it can
    refreshLogin: LoginOutFn
    //what you should call when the user clicks 'login'
    login: LoginOutFn
    logout: LoginOutFn
    jwtToken: JwtTokenFn
    userData: UserData
    type: string

}





